import { Button, CircularProgress, ButtonProps } from "@mui/material";

type MuiButtonProps = {
  isLoading?: boolean;
  label: string;
  startIcon?: React.ReactNode; // Allow external startIcon
} & ButtonProps;

const MuiButton = ({
  disabled = false,
  onClick,
  isLoading = false,
  variant = "contained",
  size = "medium",
  label,
  startIcon,
  ...rest
}: MuiButtonProps) => {
  return (
    <Button
      fullWidth
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled || isLoading}
      startIcon={
        isLoading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          startIcon
        )
      }
      {...rest}
    >
      {isLoading ? "Loading..." : label}
    </Button>
  );
};

export default MuiButton;





 



